import { render, staticRenderFns } from "./PurchaseInList.vue?vue&type=template&id=f5719ff4&scoped=true"
import script from "./PurchaseInList.vue?vue&type=script&lang=js"
export * from "./PurchaseInList.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInList.vue?vue&type=style&index=0&id=f5719ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5719ff4",
  null
  
)

export default component.exports